<template>
  <gas-page-shell :breadcrumb="['设备管理', '回收站']">
    <div class="search-section">
      <div class="section-title"><span class="title-bar"></span>检索条件</div>
      <el-form :inline="true" :model="query" size="small" label-width="80px" class="search-form">
        <el-form-item label="设备">
          <el-input v-model="query.keyword" clearable placeholder="名称/编号/站点/硬件编码" style="width:220px" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-panel">
      <div class="table-toolbar">
        <div class="table-title-group">
          <span class="table-title">回收站 <em>共 {{ total }} 条记录</em></span>
          <gas-table-toolbar
            :columns="tableColumnDefs"
            :visible-map.sync="tableColumnVisible"
            :selected-count="selectedIds.length"
            :show-batch-delete="tableCanBatchDelete"
            @batch-delete="batchRemove('彻底删除将清除所选设备的全部相关数据，且不可恢复。确认继续？')"
          />
        </div>
        <div class="toolbar-actions">
          <el-button size="small" type="primary" icon="el-icon-refresh-left" :disabled="!selectedIds.length" @click="batchRestore">批量恢复</el-button>
          <el-button size="small" icon="el-icon-refresh" circle @click="loadData" />
        </div>
      </div>

      <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="44" align="center" />
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="{ $index }">{{ rowNo($index) }}</template>
        </el-table-column>
        <el-table-column prop="siteName" label="站点名称" min-width="120" show-overflow-tooltip />
        <el-table-column label="设备名称/编号" min-width="160">
          <template slot-scope="{ row }">
            <div>{{ row.deviceName || '—' }}</div>
            <div class="device-code">{{ row.deviceCode || '—' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="terminalType" label="设备类型" width="110" show-overflow-tooltip />
        <el-table-column prop="projectCategoryName" label="项目分类" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.projectCategoryName || '—' }}</template>
        </el-table-column>
        <el-table-column prop="model" label="型号" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.model || '—' }}</template>
        </el-table-column>
        <el-table-column prop="recycleTime" label="进入回收站时间" width="170" />
        <el-table-column prop="updateTime" label="更新时间" width="170" />
        <el-table-column label="操作" width="140" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="restoreRow(row)">恢复</el-button>
            <el-button type="text" size="small" class="op-del" @click="removeRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.pageNum"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasCrudPage from '@/mixins/gasCrudPage'
import { gasApi } from '@/api/gas'

export default {
  components: { GasPageShell },
  mixins: [gasCrudPage],
  data() {
    return {
      idField: 'deviceId',
      listApi: params => gasApi.device.recycleList(params),
      saveApi: null,
      removeApi: id => gasApi.device.purge(id),
      batchRemoveApi: gasApi.device.batchPurge,
      tableColumnDefs: [
        { key: 'siteName', label: '站点名称' },
        { key: 'deviceName', label: '设备名称/编号' },
        { key: 'terminalType', label: '设备类型' },
        { key: 'projectCategoryName', label: '项目分类' },
        { key: 'model', label: '型号' },
        { key: 'recycleTime', label: '进入回收站时间' },
        { key: 'updateTime', label: '更新时间' }
      ],
      query: { pageNum: 1, pageSize: 10, keyword: '' }
    }
  },
  created() {
    this.initTableColumns(this.tableColumnDefs)
  },
  methods: {
    rowNo(i) {
      return (this.query.pageNum - 1) * this.query.pageSize + i + 1
    },
    resetSearch() {
      this.resetQuery()
    },
    async restoreRow(row) {
      await this.$confirm('恢复后设备将回到设备列表，可正常接收报文并通讯。确认恢复？', '恢复设备', { type: 'warning' })
      await gasApi.device.restore(row[this.idField])
      this.$message.success('已恢复')
      this.loadData()
    },
    async batchRestore() {
      if (!this.selectedIds.length) return this.$message.warning('请先勾选要恢复的设备')
      await this.$confirm(`恢复后所选 ${this.selectedIds.length} 台设备将回到设备列表，可正常接收报文并通讯。确认继续？`, '批量恢复', { type: 'warning' })
      await gasApi.device.batchRestore({ ids: this.selectedIds })
      this.$message.success('已恢复')
      this.selectedIds = []
      this.loadData()
    },
    async removeRow(row) {
      await this.$confirm('彻底删除将清除该设备的终端、报文、指标、报表、告警和推送等全部相关数据，且不可恢复。确认继续？', '彻底删除', { type: 'warning' })
      await this.removeApi(row[this.idField])
      this.$message.success('已彻底删除')
      this.loadData()
    }
  }
}
</script>

<style scoped lang="scss">
.search-section {
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  padding: 16px 16px 4px;
  margin-bottom: 16px;
}
.section-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 12px;
}
.title-bar {
  width: 3px;
  height: 14px;
  background: #1677ff;
  margin-right: 8px;
}
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.device-code { color: #86909c; font-size: 12px; }
.op-del { color: #f53f3f; }
.pager { margin-top: 16px; text-align: right; }
</style>
